import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal, ChapterTag } from "@/components/Reveal";

const STATS = [
  {
    value: 12,
    prefix: "",
    suffix: "",
    label: "Training Batches Completed",
    subtext: "By August 2026",
    testId: "stat-batches-completed",
  },
  {
    value: 200,
    prefix: "~",
    suffix: "",
    label: "People Trained",
    subtext: "Over the last three years",
    testId: "stat-people-trained",
  },
  {
    value: 9,
    prefix: "",
    suffix: "",
    label: "Years of Experience",
    subtext: "Stock market training",
    testId: "stat-years-experience",
  },
];

function StatNumber({ target }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, target, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, target]);

  return <span ref={ref}>{val}</span>;
}

export default function Highlights() {
  return (
    <section
      id="highlights"
      data-testid="highlights-section"
      className="scroll-mt-20 bg-[#1C1B1A] text-[#FAF7F2]"
    >
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28 lg:px-8 lg:py-36">
        <Reveal>
          <ChapterTag number="03" label="Highlights" />
          <h2 className="mt-4 font-display text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
            Milestones built on discipline
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[#2D2A26] bg-[#2D2A26] sm:grid-cols-3">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={s.testId}
              className="bg-[#1C1B1A] p-8 transition-colors duration-500 hover:bg-[#232120] sm:p-10"
            >
              <Reveal delay={i * 0.12}>
                <p className="font-display text-5xl font-extrabold tracking-tight text-[#E05A10] sm:text-6xl">
                  {s.prefix}
                  <StatNumber target={s.value} />
                  {s.suffix}
                </p>
                <p className="mt-4 font-display text-base font-semibold text-[#FAF7F2] sm:text-lg">
                  {s.label}
                </p>
                <p className="mt-1 text-xs text-[#8C857B] sm:text-sm">
                  {s.subtext}
                </p>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
